(function () {
  'use strict';

  if (window.__mdcStorefrontPolish) return;
  window.__mdcStorefrontPolish = true;

  var mdcLanguage = ((document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'fr').toLowerCase().split(/[-_]/)[0]);
  var mdcTranslations = {
    "en": {
      "Cadeau offert avec achat": "Gift with purchase",
      "Bleu ciel": "Sky blue",
      "Bordeaux": "Burgundy",
      "Voir les étapes": "View the steps",
      "Voir les démonstrations vidéo": "Watch the video demonstrations",
      "Voir les étapes et les vidéos": "View the steps and videos",
      "Accéder au guide sur cette page": "Open the guide on this page",
      "Couleur": "Colour",
      "Format et puissance": "Size and power",
      "Format": "Size",
      "Teinte de lumière": "Light colour",
      "Nombre d’ampoules": "Number of bulbs",
      "Indisponible": "Unavailable",
      "Blanc chaud": "Warm white",
      "Lumière chaude": "Warm light",
      "Lumière blanche": "White light",
      "Blanc": "White",
      "blanc": "white",
      "Noir": "Black",
      "Gris": "Grey",
      "Doré": "Gold",
      "Argenté": "Silver",
      "Vert": "Green",
      "vert": "green",
      "Rouge": "Red",
      "rouge": "red",
      "Bleu": "Blue",
      "Rose": "Pink",
      "rose": "pink",
      "Bronze": "Bronze",
      "Rond brillant": "Glossy round",
      "Rond dépoli": "Frosted round",
      "Demi-cercle dépoli": "Frosted semicircle",
      "Demi-cercle brillant": "Glossy semicircle",
      "Chine continentale": "Mainland China",
      "3 teintes de lumière": "3 light colours",
      "Sans ampoule": "Bulb not included",
      "adaptateur non inclus": "adapter not included",
      " et ": " and ",
      "Fermer le panier": "Close cart",
      "Produits précédents": "Previous products",
      "Produits suivants": "Next products",
      "Produits recommandés": "Product recommendations",
      "Récapitulatif du panier": "Cart summary",
      "Information livraison": "Delivery information",
      "Actions sur cet article": "Item actions",
      "Codes de réduction appliqués": "Applied discount codes",
      "Code de réduction": "Discount code",
      "Appliquer le code de réduction": "Apply discount code",
      "Ajouter la livraison protégée": "Add delivery protection",
      "Votre cadeau": "Your gift",
      " : débloqué": ": unlocked",
      "Réduction": "Discount",
      "Prix initial :": "Regular price:",
      "Prix remisé :": "Sale price:",
      "Choisir la variante de ": "Select variant for ",
      "Retirer le code de réduction ": "Remove discount code ",
      "Panier contenant ": "Shopping cart with ",
      " articles": " items",
      "Retirer ": "Remove ",
      " du panier": " from cart",
      "Réduire la quantité de ": "Decrease quantity of ",
      "Augmenter la quantité de ": "Increase quantity of ",
      "Ajouter ": "Add ",
      " au panier": " to cart",
      ", quantité ": ", quantity "
    },
    "ar": {
      "Cadeau offert avec achat": "هدية مع الشراء",
      "Bleu ciel": "أزرق سماوي",
      "Bordeaux": "عنابي",
      "Voir les étapes": "عرض الخطوات",
      "Voir les démonstrations vidéo": "مشاهدة العروض التوضيحية بالفيديو",
      "Voir les étapes et les vidéos": "عرض الخطوات والفيديوهات",
      "Accéder au guide sur cette page": "فتح الدليل في هذه الصفحة",
      "Couleur": "اللون",
      "Format et puissance": "المقاس والقدرة",
      "Format": "المقاس",
      "Teinte de lumière": "لون الإضاءة",
      "Nombre d’ampoules": "عدد المصابيح",
      "Indisponible": "غير متوفر",
      "Blanc chaud": "أبيض دافئ",
      "Lumière chaude": "إضاءة دافئة",
      "Lumière blanche": "إضاءة بيضاء",
      "Blanc": "أبيض",
      "blanc": "أبيض",
      "Noir": "أسود",
      "Gris": "رمادي",
      "Doré": "ذهبي",
      "Argenté": "فضي",
      "Vert": "أخضر",
      "vert": "أخضر",
      "Rouge": "أحمر",
      "rouge": "أحمر",
      "Bleu": "أزرق",
      "Rose": "وردي",
      "rose": "وردي",
      "Bronze": "برونزي",
      "Rond brillant": "دائري لامع",
      "Rond dépoli": "دائري مصنفر",
      "Demi-cercle dépoli": "نصف دائرة مصنفرة",
      "Demi-cercle brillant": "نصف دائرة لامع",
      "Chine continentale": "الصين القارية",
      "3 teintes de lumière": "3 ألوان إضاءة",
      "Sans ampoule": "المصباح غير مشمول",
      "adaptateur non inclus": "المحوّل غير مشمول",
      " et ": " و",
      "Fermer le panier": "إغلاق السلة",
      "Produits précédents": "المنتجات السابقة",
      "Produits suivants": "المنتجات التالية",
      "Produits recommandés": "منتجات مقترحة",
      "Récapitulatif du panier": "ملخص السلة",
      "Information livraison": "معلومات التوصيل",
      "Actions sur cet article": "خيارات هذا المنتج",
      "Codes de réduction appliqués": "رموز الخصم المطبّقة",
      "Code de réduction": "رمز الخصم",
      "Appliquer le code de réduction": "تطبيق رمز الخصم",
      "Ajouter la livraison protégée": "إضافة حماية التوصيل",
      "Votre cadeau": "هديتك",
      " : débloqué": " : متاح",
      "Réduction": "خصم",
      "Prix initial :": "السعر الأصلي:",
      "Prix remisé :": "السعر بعد الخصم:",
      "Choisir la variante de ": "اختر خيار ",
      "Retirer le code de réduction ": "إزالة رمز الخصم ",
      "Panier contenant ": "سلة تحتوي على ",
      " articles": " منتجات",
      "Retirer ": "إزالة ",
      " du panier": " من السلة",
      "Réduire la quantité de ": "تقليل كمية ",
      "Augmenter la quantité de ": "زيادة كمية ",
      "Ajouter ": "إضافة ",
      " au panier": " إلى السلة",
      ", quantité ": "، الكمية "
    },
    "es": {
      "Cadeau offert avec achat": "Regalo con compra",
      "Bleu ciel": "Azul cielo",
      "Bordeaux": "Burdeos",
      "Voir les étapes": "Ver los pasos",
      "Voir les démonstrations vidéo": "Ver las demostraciones en vídeo",
      "Voir les étapes et les vidéos": "Ver los pasos y los vídeos",
      "Accéder au guide sur cette page": "Abrir la guía en esta página",
      "Couleur": "Color",
      "Format et puissance": "Formato y potencia",
      "Format": "Formato",
      "Teinte de lumière": "Tono de luz",
      "Nombre d’ampoules": "Número de bombillas",
      "Indisponible": "No disponible",
      "Blanc chaud": "Blanco cálido",
      "Lumière chaude": "Luz cálida",
      "Lumière blanche": "Luz blanca",
      "Blanc": "Blanco",
      "blanc": "blanco",
      "Noir": "Negro",
      "Gris": "Gris",
      "Doré": "Dorado",
      "Argenté": "Plateado",
      "Vert": "Verde",
      "vert": "verde",
      "Rouge": "Rojo",
      "rouge": "rojo",
      "Bleu": "Azul",
      "Rose": "Rosa",
      "rose": "rosa",
      "Bronze": "Bronce",
      "Rond brillant": "Redondo brillante",
      "Rond dépoli": "Redondo esmerilado",
      "Demi-cercle dépoli": "Semicírculo esmerilado",
      "Demi-cercle brillant": "Semicírculo brillante",
      "Chine continentale": "China continental",
      "3 teintes de lumière": "3 tonos de luz",
      "Sans ampoule": "Sin bombilla",
      "adaptateur non inclus": "adaptador no incluido",
      " et ": " y ",
      "Fermer le panier": "Cerrar carrito",
      "Produits précédents": "Productos anteriores",
      "Produits suivants": "Productos siguientes",
      "Produits recommandés": "Productos recomendados",
      "Récapitulatif du panier": "Resumen del carrito",
      "Information livraison": "Información de entrega",
      "Actions sur cet article": "Acciones del artículo",
      "Codes de réduction appliqués": "Códigos de descuento aplicados",
      "Code de réduction": "Código de descuento",
      "Appliquer le code de réduction": "Aplicar código de descuento",
      "Ajouter la livraison protégée": "Añadir protección de entrega",
      "Votre cadeau": "Tu regalo",
      " : débloqué": " : desbloqueado",
      "Réduction": "Descuento",
      "Prix initial :": "Precio original:",
      "Prix remisé :": "Precio rebajado:",
      "Choisir la variante de ": "Elegir la variante de ",
      "Retirer le code de réduction ": "Eliminar el código de descuento ",
      "Panier contenant ": "Carrito con ",
      " articles": " artículos",
      "Retirer ": "Quitar ",
      " du panier": " del carrito",
      "Réduire la quantité de ": "Reducir la cantidad de ",
      "Augmenter la quantité de ": "Aumentar la cantidad de ",
      "Ajouter ": "Añadir ",
      " au panier": " al carrito",
      ", quantité ": ", cantidad "
    }
  };
  function mdcText(text) {
    var translations = mdcTranslations[mdcLanguage];
    return translations && Object.prototype.hasOwnProperty.call(translations, text) ? translations[text] : text;
  }

  function mdcDisplayText(value) {
    var trimmed = value.trim();
    var translated = mdcText(trimmed);
    if (translated !== trimmed) return value.replace(trimmed, translated);
    return value.replace(/Prix initial :|Prix remisé :/g, mdcText);
  }
  function mdcOptionText(value) {
    if (mdcLanguage === 'fr') return value;
    return value.replace(/Bleu ciel|Bordeaux|Blanc chaud|Lumière chaude|Lumière blanche|Demi-cercle dépoli|Demi-cercle brillant|Rond brillant|Rond dépoli|Chine continentale|3 teintes de lumière|Sans ampoule|adaptateur non inclus|Indisponible|Argenté|Bronze|Blanc|Noir|Gris|Doré|Vert|Rouge|Bleu|Rose|blanc|vert|rouge|rose| et /g, mdcText);
  }
  function mdcAriaText(value) {
    if (mdcLanguage === 'fr') return value;
    var exact = mdcText(value);
    if (exact !== value) return exact;
    return value
      .replace(/^Choisir la variante de (.+)$/, function (_, item) { return mdcText('Choisir la variante de ') + item; })
      .replace(/^Retirer le code de réduction (.+)$/, function (_, code) { return mdcText('Retirer le code de réduction ') + code; })
      .replace(/^Panier contenant (\d+) articles$/, function (_, count) { return mdcText('Panier contenant ') + count + mdcText(' articles'); })
      .replace(/^Retirer (.+) du panier$/, function (_, item) { return mdcText('Retirer ') + mdcOptionText(item) + mdcText(' du panier'); })
      .replace(/^Réduire la quantité de (.+)$/, function (_, item) { return mdcText('Réduire la quantité de ') + mdcOptionText(item); })
      .replace(/^Augmenter la quantité de (.+)$/, function (_, item) { return mdcText('Augmenter la quantité de ') + mdcOptionText(item); })
      .replace(/^Ajouter (.+) au panier$/, function (_, item) { return mdcText('Ajouter ') + item + mdcText(' au panier'); })
      .replace(/ : débloqué$/, mdcText(' : débloqué'))
      .replace(/, quantité (\d+)$/, function (_, quantity) { return mdcText(', quantité ') + quantity; });
  }

  var ownTextChanges = new WeakMap();
  var ownAriaLabels = new WeakMap();

  function writeText(node, value) {
    value = mdcDisplayText(value);
    if (node.textContent === value) return;
    node.textContent = value;
    ownTextChanges.set(node, { value: value, firstChild: node.firstChild });
  }

  function writeAriaLabel(element, value) {
    value = mdcAriaText(value);
    if (element.getAttribute('aria-label') === value) return;
    element.setAttribute('aria-label', value);
    ownAriaLabels.set(element, value);
  }

  function isOwnTranslation(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'aria-label') {
      if (!ownAriaLabels.has(mutation.target) ||
          mutation.target.getAttribute('aria-label') !== ownAriaLabels.get(mutation.target)) return false;
      ownAriaLabels.delete(mutation.target);
      return true;
    }
    var previous = ownTextChanges.get(mutation.target);
    if (!previous || mutation.target.textContent !== previous.value) return false;
    if (mutation.type !== 'characterData') {
      if (mutation.type !== 'childList' || mutation.target.firstChild !== previous.firstChild) return false;
      if (!Array.prototype.every.call(mutation.addedNodes, function (node) { return node.nodeType === Node.TEXT_NODE; }) ||
          !Array.prototype.every.call(mutation.removedNodes, function (node) { return node.nodeType === Node.TEXT_NODE; })) return false;
    }
    ownTextChanges.delete(mutation.target);
    return true;
  }

  function clearTranslationRecords() {
    ownTextChanges = new WeakMap();
    ownAriaLabels = new WeakMap();
  }

  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function optionLabel(value) {
    var key = normalize(value);
    if (/body color|body colour|^color$|^colour$|^couleur$|^couluer$|finish|finition/.test(key)) return mdcText('Couleur');
    if (/size.*watt|watt.*size|taille.*watt|dimension.*watt/.test(key)) return mdcText('Format et puissance');
    if (/^size$|taille|dimension|diametre|hauteur|largeur|longueur/.test(key)) return mdcText('Format');
    if (/light color|emitting color|color temperature|temperature|couleur claire|teinte/.test(key)) return mdcText('Teinte de lumière');
    if (/number of bulbs|nombre d.*ampoule/.test(key)) return mdcText("Nombre d’ampoules");
    return value;
  }

  function optionValue(value) {
    var suffix = '';
    var source = value || '';
    var unavailable = source.match(/\s+-\s+(indisponible|unavailable)\s*$/i);
    if (unavailable) {
      suffix = ' - Indisponible';
      source = source.slice(0, unavailable.index);
    }

    var exact = {
      white: 'Blanc', black: 'Noir', grey: 'Gris', gray: 'Gris', gold: 'Doré',
      silver: 'Argenté', green: 'Vert', red: 'Rouge', blue: 'Bleu', pink: 'Rose',
      bronze: 'Bronze', warm: 'Blanc chaud', 'warm white': 'Blanc chaud',
      'warm light': 'Lumière chaude', 'white light': 'Lumière blanche',
      'ac 220v-240v': '220–240 V', 'ac 110v-130v': '110–130 V',
      'round glossy 12cm': 'Rond brillant — 12 cm',
      'round glossy 15cm': 'Rond brillant — 15 cm',
      'round glossy 18cm': 'Rond brillant — 18 cm',
      'round glossy 20cm': 'Rond brillant — 20 cm',
      'round frosted 12cm': 'Rond dépoli — 12 cm',
      'round frosted15': 'Rond dépoli — 15 cm',
      'round frosted 15cm': 'Rond dépoli — 15 cm',
      'round frosted 18cm': 'Rond dépoli — 18 cm',
      'round frosted 20cm': 'Rond dépoli — 20 cm',
      'semicirlc frosted15': 'Demi-cercle dépoli — 15 cm',
      'semicircle frosted18': 'Demi-cercle dépoli — 18 cm',
      'semicircle glossy15': 'Demi-cercle brillant — 15 cm',
      'semicircle glossy18': 'Demi-cercle brillant — 18 cm',
      'china mainland': 'Chine continentale',
      'black white green': 'Noir, blanc et vert',
      'black green red': 'Noir, vert et rouge',
      'white green pink': 'Blanc, vert et rose',
      'white pink red': 'Blanc, rose et rouge',
      'white pink': 'Blanc et rose',
      'black white': 'Noir et blanc',
      'white green-a': 'Blanc et vert — A',
      'warm white (2700-3500k)': 'Blanc chaud (2700–3500 K)',
      '3-color light': '3 teintes de lumière',
      '3 colors in one lamp': '3 teintes de lumière',
      'no light bulb': 'Sans ampoule'
    };
    var key = normalize(source);
    var result = exact[key] || source;

    result = result
      .replace(/\bwhite\b/gi, 'Blanc')
      .replace(/\bblack\b/gi, 'Noir')
      .replace(/\bgr(?:e|a)y\b/gi, 'Gris')
      .replace(/\bgold\b/gi, 'Doré')
      .replace(/\bsilver\b/gi, 'Argenté')
      .replace(/\bno\s+adapt(?:er|or)?\b/gi, 'adaptateur non inclus')
      .replace(/\bwithout\s+adapt(?:er|or)?\b/gi, 'adaptateur non inclus')
      .replace(/\b([1-9])([0-9]{3})\s*k\b/gi, '$1 $2 K')
      .replace(/\s*\|\s*/g, ' · ')
      .replace(/(\d)\s*-\s*(\d+)\s*w\b/gi, '$1–$2 W')
      .replace(/\s{2,}/g, ' ')
      .trim();

    return mdcOptionText(result + suffix);
  }

  function replaceLeadingText(element, value) {
    var nodes = Array.prototype.slice.call(element.childNodes);
    var textNode = nodes.find(function (node) { return node.nodeType === Node.TEXT_NODE && node.textContent.trim(); });
    if (textNode) writeText(textNode, value + ' ');
  }

  function variantTitle(value) {
    return (value || '')
      .split(/\s*\/\s*/)
      .map(function (part) { return optionValue(part); })
      .join(' / ');
  }

  function localizeEmbeddedVariantValues(value) {
    var pairs = [
      ['Warm White (2700-3500K)', 'Blanc chaud (2700–3500 K)'],
      ['Black White Green', 'Noir, blanc et vert'],
      ['Black Green Red', 'Noir, vert et rouge'],
      ['White Green Pink', 'Blanc, vert et rose'],
      ['White Pink Red', 'Blanc, rose et rouge'],
      ['3 colors in one Lamp', '3 teintes de lumière'],
      ['3-color light', '3 teintes de lumière'],
      ['No light bulb', 'Sans ampoule'],
      ['White Green-A', 'Blanc et vert — A'],
      ['Black White', 'Noir et blanc'],
      ['White Pink', 'Blanc et rose']
    ];
    return pairs.reduce(function (translated, pair) {
      return translated.replace(new RegExp(pair[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'), pair[1]);
    }, value || '');
  }

  function preserveAndLocalize(element, rawKey, renderedKey) {
    var current = element.textContent.trim();
    var raw = current === element.dataset[renderedKey] ? element.dataset[rawKey] : current;
    var rendered = variantTitle(raw);
    if (element.dataset[rawKey] !== raw) element.dataset[rawKey] = raw;
    if (element.dataset[renderedKey] !== rendered) element.dataset[renderedKey] = rendered;
    if (current !== rendered) writeText(element, rendered);
  }

  function isFranceMarket() {
    var country = window.Shopify && window.Shopify.country;
    var context = document.getElementById('MdcMaisonDouceProductData');
    return (country || (context && context.dataset.country)) === 'FR';
  }

  function isNacraVariantSelect(select) {
    return select && select.tagName === 'SELECT' && Array.prototype.some.call(select.options, function (option) {
      return option.value === '54343518748990';
    });
  }

  function isNacraFranceOption(option) {
    if (!option) return false;
    var raw = normalize(option.dataset.mdcRawLabel || option.textContent);
    return /220|230|240/.test(raw);
  }

  function filterNacraCartVariants(select) {
    if (!isNacraVariantSelect(select)) return;
    var isFrance = isFranceMarket();
    Array.prototype.forEach.call(select.options, function (option) {
      var blocked = isFrance && !isNacraFranceOption(option);
      if (blocked) {
        if (option.dataset.mdcFranceBlocked !== 'true') {
          if (option.dataset.mdcPreviousDisabled !== String(option.disabled)) option.dataset.mdcPreviousDisabled = String(option.disabled);
          if (option.dataset.mdcPreviousHidden !== String(option.hidden)) option.dataset.mdcPreviousHidden = String(option.hidden);
        }
        if (option.dataset.mdcFranceBlocked !== 'true') option.dataset.mdcFranceBlocked = 'true';
        if (!option.disabled) option.disabled = true;
        var blockedHidden = !option.selected;
        if (option.hidden !== blockedHidden) option.hidden = blockedHidden;
      } else if (option.dataset.mdcFranceBlocked === 'true') {
        var previousDisabled = option.dataset.mdcPreviousDisabled === 'true';
        var previousHidden = option.dataset.mdcPreviousHidden === 'true';
        if (option.disabled !== previousDisabled) option.disabled = previousDisabled;
        if (option.hidden !== previousHidden) option.hidden = previousHidden;
        delete option.dataset.mdcFranceBlocked;
        if (option.dataset.mdcPreviousDisabled !== undefined) delete option.dataset.mdcPreviousDisabled;
        if (option.dataset.mdcPreviousHidden !== undefined) delete option.dataset.mdcPreviousHidden;
      }
    });
    if ((!select.dataset.mdcLastCartSelection || !isFrance || isNacraFranceOption(select.selectedOptions[0])) &&
        select.dataset.mdcLastCartSelection !== select.value) {
      select.dataset.mdcLastCartSelection = select.value;
    }
  }

  function localizeEssentialCart(scope) {
    var portal = scope && scope.closest && scope.closest('#essential-cart-drawer-portal');
    if (!portal && scope && scope.querySelector) portal = scope.querySelector('#essential-cart-drawer-portal');
    if (!portal) return;
    var cartDialog = portal.querySelector('#cart-drawer > [role="dialog"]');
    if (cartDialog && cartDialog.style.visibility === 'hidden') return;
    localizeEssentialAddButtons(portal);

    portal.querySelectorAll('select[aria-label]').forEach(function (select) {
      Array.prototype.forEach.call(select.options, function (option) {
        preserveAndLocalize(option, 'mdcRawLabel', 'mdcRenderedLabel');
      });
      filterNacraCartVariants(select);

      var aria = select.getAttribute('aria-label') || '';
      var product = aria.replace(/^(?:Select variant for|Choisir la variante de|اختر خيار|Elegir la variante de)\s*/i, '').trim();
      var localizedAria = product ? 'Choisir la variante de ' + product : '';
      if (localizedAria && aria !== localizedAria) writeAriaLabel(select, localizedAria);
    });

    portal.querySelectorAll('[aria-label]').forEach(function (element) {
      var label = element.getAttribute('aria-label') || '';
      var translated = label
        .replace(/^Close cart$/, 'Fermer le panier')
        .replace(/^Previous products$/, 'Produits précédents')
        .replace(/^Next products$/, 'Produits suivants')
        .replace(/^Product recommendations$/, 'Produits recommandés')
        .replace(/^Cart summary$/, 'Récapitulatif du panier')
        .replace(/^Announcement$/, 'Information livraison')
        .replace(/^Item actions$/, 'Actions sur cet article')
        .replace(/^Applied discount codes$/, 'Codes de réduction appliqués')
        .replace(/^Discount code$/, 'Code de réduction')
        .replace(/^Apply discount code$/, 'Appliquer le code de réduction')
        .replace(/^Add Livraison protégée$/, 'Ajouter la livraison protégée')
        .replace(/^Reward progress$/, 'Votre cadeau')
        .replace(/: unlocked$/, ' : débloqué')
        .replace(/^Remove discount code (.+)$/, 'Retirer le code de réduction $1')
        .replace(/^Shopping cart with (\d+) items$/, 'Panier contenant $1 articles')
        .replace(/^Remove (.+) from cart$/i, function (_, item) { return 'Retirer ' + localizeEmbeddedVariantValues(item) + ' du panier'; })
        .replace(/^Decrease quantity of (.+)$/i, function (_, item) { return 'Réduire la quantité de ' + localizeEmbeddedVariantValues(item); })
        .replace(/^Increase quantity of (.+)$/i, function (_, item) { return 'Augmenter la quantité de ' + localizeEmbeddedVariantValues(item); })
        .replace(/^Add (.+) to cart$/i, function (_, item) { return 'Ajouter ' + item + ' au panier'; })
        .replace(/, quantity (\d+)$/i, ', quantité $1')
        .replace(/€\s*(\d[\d\s\u00a0\u202f]*,\d{2})/g, '$1\u00a0€');
      if (translated !== label) writeAriaLabel(element, translated);
    });

    portal.querySelectorAll('img[data-essential-cart-element="masked-icon"][src*="/order-upsell/shipping-protection."]').forEach(function (image) {
      if (image.alt === 'Masked icon') {
        image.alt = '';
        image.setAttribute('aria-hidden', 'true');
      }
    });

    portal.querySelectorAll('[data-essential-cart-element="line-item-discounts"]').forEach(function (discount) {
      var walker = document.createTreeWalker(discount, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var node = walker.currentNode;
        if (node.nodeValue.trim() === 'Discount') writeText(node, node.nodeValue.replace('Discount', 'Réduction'));
        else if (node.nodeValue.trim() === 'Cadeau offert avec achat') writeText(node, node.nodeValue);
      }
    });

    portal.querySelectorAll('[data-essential-cart-element="line-item-price"], [data-essential-cart-element="upsell-price"], [data-essential-cart-element="subtotal-wrapper"], [data-essential-cart-element="discount-code-amount-value"], [data-essential-cart-element="cart-drawer-checkout-button-text"], [data-essential-cart-element="order-upsell-item"]').forEach(function (price) {
      var walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var node = walker.currentNode;
        var localized = node.nodeValue
          .replace(/Regular price:/g, 'Prix initial :')
          .replace(/Sale price:/g, 'Prix remisé :')
          .replace(/€\s*(\d[\d\s\u00a0\u202f]*,\d{2})/g, '$1\u00a0€');
        if (localized !== node.nodeValue) writeText(node, localized);
      }
    });

  }

  function localizeCartPage(scope) {
    var cart = scope && scope.closest && scope.closest('.cart-page');
    if (!cart && scope && scope.querySelector) cart = scope.querySelector('.cart-page');
    if (!cart) return;
    cart.querySelectorAll('.cart-items__variants-wrapper > ul > li').forEach(function (discount) {
      if (discount.textContent.trim() === 'Discount') writeText(discount, 'Réduction');
    });
    cart.querySelectorAll('.cart-items__unit-price-wrapper, .cart-items__price, .cart-totals__total-value, .cart-items__table caption').forEach(function (price) {
      var walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var node = walker.currentNode;
        var localized = node.nodeValue.replace(/€\s*(\d[\d\s\u00a0\u202f]*,\d{2})/g, '$1\u00a0€');
        if (localized !== node.nodeValue) writeText(node, localized);
      }
    });
  }

  function mdcLocalizedHref(value) {
    if (!/^(en|es|ar)$/.test(mdcLanguage) || !value || /^\s*#/.test(value)) return value;
    try {
      var url = new URL(value, location.href);
      if (!/^https?:$/.test(url.protocol) || url.origin !== new URL(location.href).origin) return value;
      if (/^\/(?:fr|en|ar|es)(?:\/|$)/i.test(url.pathname)) return value;
      if (!/^\/(?:pages|products|collections|blogs|policies|apps|cart|search)(?:\/|$)/.test(url.pathname)) return value;
      return '/' + mdcLanguage + url.pathname + url.search + url.hash;
    } catch (_) {
      return value;
    }
  }

  function localizeInternalLinks(scope) {
    if (!/^(en|es|ar)$/.test(mdcLanguage)) return;
    var links = Array.prototype.slice.call(scope.querySelectorAll('a[href]'));
    if (scope.matches && scope.matches('a[href]')) links.unshift(scope);
    links.forEach(function (link) {
      var current = link.getAttribute('href');
      var localized = mdcLocalizedHref(current);
      if (localized !== current) link.setAttribute('href', localized);
    });
  }

  function mdcDimensionText(value) {
    var words = {
      en: { 'Diamètre': 'diameter', 'Hauteur': 'height', 'pouces': 'inches' },
      es: { 'Diamètre': 'diámetro', 'Hauteur': 'altura', 'pouces': 'pulgadas' },
      ar: { 'Diamètre': 'قطر', 'Hauteur': 'ارتفاع', 'pouces': 'بوصة' }
    }[mdcLanguage];
    if (!words) return value;
    return value.replace(/\b(Diamètre|Hauteur|pouces)\b/g, function (word) { return words[word]; });
  }

  function localizeVariantDimensions(scope) {
    if (!/^(en|es|ar)$/.test(mdcLanguage)) return;
    var roots = Array.prototype.slice.call(scope.querySelectorAll('variant-picker, sticky-add-to-cart'));
    if (scope.matches && scope.matches('variant-picker, sticky-add-to-cart')) roots.unshift(scope);
    roots.forEach(function (component) {
      var walker = document.createTreeWalker(component, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var node = walker.currentNode;
        if (node.parentElement && node.parentElement.closest('script, style, template, textarea')) continue;
        var translated = mdcDimensionText(node.nodeValue);
        if (translated !== node.nodeValue) writeText(node, translated);
      }
    });
  }

  function localizeEssentialAddButtons(portal) {
    var label = { en: 'Add', es: 'Añadir', ar: 'إضافة' }[mdcLanguage];
    if (!label) return;
    portal.querySelectorAll('button, [role="button"]').forEach(function (button) {
      var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var node = walker.currentNode;
        if (node.nodeValue.trim() === 'Ajouter') writeText(node, node.nodeValue.replace('Ajouter', label));
      }
    });
  }

  function repairRtlSkipLinks() {
    if (mdcLanguage !== 'ar' || document.documentElement.dir !== 'rtl' || !document.head || document.getElementById('MdcRtlSkipLinkFix')) return;
    var style = document.createElement('style');
    style.id = 'MdcRtlSkipLinkFix';
    style.textContent = 'html[dir="rtl"] .skip-to-content-link:not(:focus){left:0;right:auto;width:1px;height:1px;clip-path:inset(50%);overflow:hidden;white-space:nowrap}';
    document.head.appendChild(style);
  }

  function localizeGuideActions(scope) {
    if (!/^(en|es|ar)$/.test(mdcLanguage)) return;
    scope.querySelectorAll('.mdc-family-guides__local-access a, a[data-guide-local-access]').forEach(function (link) {
      var current = link.textContent.trim();
      var translated = mdcText(current);
      if (translated !== current) writeText(link, translated);
    });
    scope.querySelectorAll('.mdc-family-guides__local-access[aria-label]').forEach(function (nav) {
      var current = nav.getAttribute('aria-label');
      var translated = mdcText(current);
      if (translated !== current) writeAriaLabel(nav, translated);
    });
  }

  function polish(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.variant-option > legend').forEach(function (legend) {
      if (legend.closest('[data-mdc-dimensions="true"]') || legend.hasAttribute('data-mdc-preserve-option-label')) return;
      var firstText = Array.prototype.find.call(legend.childNodes, function (node) {
        return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
      });
      if (!firstText) return;
      var label = optionLabel(firstText.textContent.trim());
      if (firstText.textContent.trim() !== label) writeText(firstText, label + ' ');
      if (legend.dataset.mdcLabelPolished !== 'true') legend.dataset.mdcLabelPolished = 'true';
    });

    scope.querySelectorAll('.variant-option--dropdowns > label').forEach(function (label) {
      if (label.closest('[data-mdc-dimensions="true"]')) return;
      var text = optionLabel(label.textContent.trim());
      if (label.textContent.trim() !== text) writeText(label, text);
      if (label.dataset.mdcLabelPolished !== 'true') label.dataset.mdcLabelPolished = 'true';
    });

    scope.querySelectorAll('[data-testid="variant-option-single"]').forEach(function (single) {
      if (single.closest('[data-mdc-dimensions="true"]')) return;
      if (single.dataset.mdcLabelPolished === 'true') return;
      var value = single.querySelector('[data-testid="variant-option-single-value"]');
      if (value) writeText(value, optionValue(value.textContent.trim()));
      replaceLeadingText(single, optionLabel(single.textContent.replace(value ? value.textContent : '', '').trim()));
      single.dataset.mdcLabelPolished = 'true';
    });

    scope.querySelectorAll('.variant-option__button-label__text').forEach(function (text) {
      if (text.dataset.mdcValuePolished === 'true') return;
      writeText(text, optionValue(text.textContent.trim()));
      text.dataset.mdcValuePolished = 'true';
    });

    scope.querySelectorAll('.variant-option__button-label input').forEach(function (input) {
      var visible = mdcDimensionText(input.getAttribute('data-mdc-display-value') || optionValue(input.value));
      if (input.getAttribute('aria-label') !== visible) writeAriaLabel(input, visible);
      var label = input.closest('label');
      if (label && label.closest('[data-mdc-color-only]')) label.removeAttribute('title');
      else if (label && label.getAttribute('title') !== visible) label.setAttribute('title', visible);
    });

    scope.querySelectorAll('.variant-option__select option').forEach(function (option) {
      if (option.dataset.mdcValuePolished === 'true') return;
      writeText(option, optionValue(option.textContent.trim()));
      option.dataset.mdcValuePolished = 'true';
    });

    scope.querySelectorAll('.mdc-product-story dt, .mdc-universe dt').forEach(function (term) {
      if (term.dataset.mdcLabelPolished === 'true') return;
      writeText(term, optionLabel(term.textContent.trim()));
      term.dataset.mdcLabelPolished = 'true';
    });

    scope.querySelectorAll('.mdc-product-story dd, .mdc-universe dd').forEach(function (definition) {
      if (definition.dataset.mdcValuePolished === 'true') return;
      writeText(definition, definition.textContent
        .split(/\s*[·|]\s*/)
        .map(function (value) { return optionValue(value); })
        .join(' · '));
      definition.dataset.mdcValuePolished = 'true';
    });

    localizeGuideActions(scope);
    localizeInternalLinks(scope);
    localizeVariantDimensions(scope);
    localizeEssentialCart(scope);
    localizeCartPage(scope);
  }

  function topLevelRoots(nodes) {
    return Array.from(nodes).filter(function (candidate) {
      if (!candidate.isConnected) return false;
      for (var parent = candidate.parentElement; parent; parent = parent.parentElement) {
        if (nodes.has(parent)) return false;
      }
      return true;
    });
  }

  // Shopify's Arabic chat UI currently keeps the theme's French activator label.
  // Localize only that original button; keep its icon, handlers and panel intact.
  function localizeArabicChat() {
    if (mdcLanguage !== 'ar' || !window.customElements) return;
    var hosts = new WeakSet();
    var runtimes = new WeakSet();

    function localizeButton(root) {
      var button = root.querySelector('button[part~="activator"]');
      var label = button && button.querySelector('.activator__label');
      if (!label || !/^(Aide|Help|مساعدة)$/.test(label.textContent.trim())) return;
      if (label.textContent !== 'مساعدة') label.textContent = 'مساعدة';
      var aria = button.getAttribute('aria-label');
      if (aria && /^(Aide|Help)(?=[\s.،]|$)/.test(aria)) {
        button.setAttribute('aria-label', aria.replace(/^(Aide|Help)/, 'مساعدة'));
      }
    }

    function bindRuntime(runtime) {
      if (runtimes.has(runtime)) return;
      runtimes.add(runtime);
      window.customElements.whenDefined('shopify-agent-runtime').then(function () {
        var root = runtime.shadowRoot;
        if (!root || !runtime.isConnected) return;
        localizeButton(root);
        new MutationObserver(function () { localizeButton(root); }).observe(root, {
          childList: true, subtree: true, characterData: true,
          attributes: true, attributeFilter: ['aria-label']
        });
      });
    }

    function bindHost(host) {
      if (hosts.has(host)) return;
      hosts.add(host);
      window.customElements.whenDefined('shopify-chat').then(function () {
        var root = host.shadowRoot;
        if (!root || !host.isConnected) return;
        function findRuntime() {
          root.querySelectorAll('shopify-agent-runtime').forEach(bindRuntime);
        }
        findRuntime();
        new MutationObserver(findRuntime).observe(root, { childList: true, subtree: true });
      });
    }

    document.querySelectorAll('shopify-chat').forEach(bindHost);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches('shopify-chat')) bindHost(node);
          node.querySelectorAll('shopify-chat').forEach(bindHost);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() {
    localizeArabicChat();
    repairRtlSkipLinks();
    polish(document);
    document.addEventListener('change', function (event) {
      var select = event.target;
      if (!select || !select.closest || !select.closest('#essential-cart-drawer-portal') || !isNacraVariantSelect(select) || !isFranceMarket()) return;
      var option = select.selectedOptions[0];
      if (option && !isNacraFranceOption(option)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        select.value = select.dataset.mdcLastCartSelection || '';
        filterNacraCartVariants(select);
        return;
      }
      if (select.dataset.mdcLastCartSelection !== select.value) select.dataset.mdcLastCartSelection = select.value;
    }, true);
    // Batch each affected component once before the next paint. App cart renders
    // can emit dozens of records; rescanning the whole portal for every record
    // multiplies work and our own translations also produce mutation records.
    var pendingRoots = new Set();
    var frame = 0;
    var componentSelector = 'variant-picker, sticky-add-to-cart, #essential-cart-drawer-portal, .cart-page, .mdc-product-story, .mdc-universe';

    function queue(root) {
      if (!root || !root.isConnected) return;
      pendingRoots.add(root);
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        var roots = topLevelRoots(pendingRoots);
        pendingRoots.clear();
        roots.forEach(polish);
      });
    }

    var cartDialogSelector = '#essential-cart-drawer-portal #cart-drawer > [role="dialog"]';
    var observedCartDialog = null;
    var observedCartPortal = null;
    var cartDialogStyleObserver = new MutationObserver(function () {
      if (!observedCartDialog || !observedCartDialog.isConnected || observedCartDialog.style.visibility === 'hidden') return;
      queue(observedCartPortal);
    });

    function bindCartDialog(scope) {
      var dialog = scope.matches && scope.matches(cartDialogSelector) ? scope : scope.querySelector(cartDialogSelector);
      if (!dialog || dialog === observedCartDialog) return;
      cartDialogStyleObserver.disconnect();
      observedCartDialog = dialog;
      observedCartPortal = dialog.closest('#essential-cart-drawer-portal');
      cartDialogStyleObserver.observe(dialog, { attributes: true, attributeFilter: ['style'] });
    }

    bindCartDialog(document);

    // Initial translations happened before observation; they have no records.
    clearTranslationRecords();
    new MutationObserver(function (mutations) {
      if (observedCartDialog && !observedCartDialog.isConnected) {
        cartDialogStyleObserver.disconnect();
        observedCartDialog = null;
        if (observedCartPortal && observedCartPortal.isConnected) bindCartDialog(observedCartPortal);
      }
      var addedRoots = new Set();
      mutations.forEach(function (mutation) {
        if (isOwnTranslation(mutation)) return;
        var target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
        queue(target && target.closest && target.closest(componentSelector));
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE && node.isConnected) addedRoots.add(node);
        });
      });
      topLevelRoots(addedRoots).forEach(function (node) {
        if (!observedCartDialog) bindCartDialog(node);
        if (node.matches(componentSelector) || node.matches('a[href]') || node.querySelector('a[href]')) queue(node);
        node.querySelectorAll(componentSelector).forEach(queue);
      });
      // Only consume one matching record per write, in this delivery. A later
      // app update must still run, even when it repeats the translated value.
      clearTranslationRecords();
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['aria-label'],
      characterData: true,
      childList: true,
      subtree: true
    });

    window.setTimeout(function () { polish(document); }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();




